import React from "react"
import "@stripe/stripe-js"
import StringsHelper from "../../common/stringsHelper"
import DatesHelper from "../../common/datesHelper"
import { StripeClient, AccountData } from "../../generated";
import { requiresUser } from "../../login/loginHelpers";
import { FreePeriodEndData } from "../../layout/LicenseAlert";
import { StripeKey } from "./buySms";

const PaymentsPage: React.FunctionComponent<{ user: AccountData }> = ({ user }) => {
    const today = DatesHelper.Today();
    const from = today.valueOf() > FreePeriodEndData.valueOf() ? today : DatesHelper.AddDays(FreePeriodEndData, 1);
    const to = DatesHelper.AddDays(from, 365);

    const onPay = async () => {
        const sessionId = (await new StripeClient().get())!;
        const stripe = window.Stripe!(StripeKey);
        stripe.redirectToCheckout({ sessionId });
    }


    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ paddingTop: "5%" }} >
            <div className="card">
                <div className="card-body">
                    <div className="jumbotron bg-white">
                        <h1 className="display-4">Acquista il tuo abbonamento!</h1>
                        <p className="lead">Acquista o rinnova il tuo abbonamento annuale. Alla ricezione del pagamento ti verrà automaticamente prorogata la scadenza del servizio.</p>
                        <hr className="my-4" />
                        <div className="row d-flex align-items-center mt-5">
                            <div className="col-12 col-md-6 text-center mb-5">
                                <h2 className="badge bg-info" style={{ fontSize: "2rem" }}>ABBONAMENTO ANNUALE</h2>
                                <p className="fw-bold" style={{ fontSize: "1.3rem" }}>Valido dal {DatesHelper.getReadableDateString(from)} al {DatesHelper.getReadableDateString(to)}</p>
                                <div>
                                    <strong style={{ fontSize: "5rem" }}>12€</strong ><span style={{ fontSize: "2.5rem" }}>/mese</span>
                                    <span className="ms-2" style={{ fontSize: "1.5rem" }}>+IVA</span>
                                </div>
                                <div className="col-12 mt-5 pe-5">
                                    <div style={{ fontSize: "1.8rem" }}>TOTALE:</div>
                                    <div>IVA compresa</div>
                                    <div className="fw-bold text-success" style={{ fontSize: "3.5rem" }}>€ {StringsHelper.toDecimalString(175.68)}</div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6" style={{ fontSize: "1.2rem" }}>
                                <div className="card">
                                    <div className="card-header bg-theme text-white">Pagamento tramite carta di credito</div>
                                    <div className="card-body">
                                        <div>Paga subito con la tua carta di credito in modo facile e sicuro.</div>
                                        <div className="mt-2 mb-2">
                                            <i className="far fa-credit-card fa-3x me-2"></i>
                                            <i className="fab fa-cc-stripe fa-3x"></i>
                                        </div>
                                        <button className="btn btn-success w-100" style={{ fontSize: "1.3rem" }} onClick={onPay}>
                                            Acquista con carta di credito
                                        </button>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header bg-secondary text-white">Pagamento tramite bonifico bancario</div>
                                    <div className="card-body">
                                        <div>Intestato a: <strong>BN TECHNOLOGIES SNC Di Belbusti Enrico & Andrea Nasoni</strong></div>
                                        <div>Iban: <strong>IT09O0306968390100000004482</strong></div>
                                        <div>Causale: <strong>Canone annuale (Vostra partita iva con cui siete iscritti)</strong></div>
                                        <div>BANCA INTESA SANPAOLO</div>
                                        <div className="alert alert-info mt-2" style={{ fontSize: "0.8rem" }}>La tua licenza verrà confermata alla ricezione del pagamento (circa 2\3 gg lavorativi)</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div >)
}

export default requiresUser(PaymentsPage);